import { StyledInputAdornment } from './styles';
import { TInputAdornmentProps } from './types';

export const InputAdornment = (props: TInputAdornmentProps) => {
  return <StyledInputAdornment {...props} />;
};
